import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M5.89 9.15Zm0 0Zm9.05.16a.58.58 0 0 1 0 .19 1.08 1.08 0 0 1-.08.19.35.35 0 0 1-.05.08 4.27 4.27 0 0 1-3.46 1.35 6.6 6.6 0 0 1-2.47-.6 6.7 6.7 0 0 0-2.49-.6l-.06-.13-.13.13h.19c1 2.17 1.87 4 1.87 4a.77.77 0 0 1-.36 1 .88.88 0 0 1-.32.07.76.76 0 0 1-.68-.43s-.75-1.61-1.7-3.61l-1 1a.75.75 0 0 1-1.06 0 .75.75 0 0 1 0-1.06l2.15-2.25 5.54-5.54 1.51-1.51a.75.75 0 0 1 1.06 0 .75.75 0 0 1 0 1.06l-1.04 1.03L14.85 9a.81.81 0 0 1 .07.31Zm-9.1-.16Zm0 0Zm.44.61-.13.13h.19Zm4.58-6.7.14-.18-.12.1Zm-2.67.17a.77.77 0 0 0-.72-.47A2.92 2.92 0 0 1 6 2.35a5 5 0 0 0-3.46-.5.48.48 0 0 0 0-.08.73.73 0 0 0-1-.37.74.74 0 0 0-.37 1s.09.2.28.59l2 4.15a.79.79 0 0 0 .55.42h.13a.78.78 0 0 0 .52-.21L8 4.05a.75.75 0 0 0 .19-.82ZM5.84 9.15Zm.31.74h.19l-.06-.13Z';
const draw24px =
  'M13.05,6.43,7,12.3a.73.73,0,0,1-.52.21H6.34a.74.74,0,0,1-.54-.42C4.27,8.82,2.94,6,2.28,4.62,2,4,1.85,3.7,1.84,3.7A.75.75,0,0,1,3.19,3l.2.43a9.2,9.2,0,0,1,6.08.89,6.45,6.45,0,0,0,2.8.78h.26a.75.75,0,0,1,.52,1.29Zm9.15,7.8v0a.35.35,0,0,0,0-.11l-3.77-7.9L21,3.54A.75.75,0,0,0,20,2.48L16.83,5.63,4.23,18.24a.75.75,0,0,0,0,1.06.75.75,0,0,0,1.06,0L8,16.63l2.66,5.63a.76.76,0,0,0,.68.43.71.71,0,0,0,.32-.07.75.75,0,0,0,.36-1L9.08,15.51,9.61,15a8.1,8.1,0,0,1,4,.92,7.79,7.79,0,0,0,3.41.91A6.47,6.47,0,0,0,22,15l.09-.1h0a.56.56,0,0,0,.11-.2A.79.79,0,0,0,22.2,14.23Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const FlagSlashFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'flagSlashFilled')) as IconWithRender;

FlagSlashFilledIcon.displayName = 'FlagSlashFilledIcon';
FlagSlashFilledIcon.propTypes = Icon.propTypes;
FlagSlashFilledIcon.renderIcon = (props) => <FlagSlashFilledIcon {...props} />;
export default FlagSlashFilledIcon;
